module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/004_AuthorsPreface#fm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/005_Translatorspreface#fm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Translator’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("I. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Main Lines in the History of Pauline Interpretation")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-1"
    }
  }, [_vm._v("1. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-2"
    }
  }, [_vm._v("2. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("F. C. Baur (the Tübingen School)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("3. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Liberal Interpretation and Its Decline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-4"
    }
  }, [_vm._v("4. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The History of Religions Approach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-5"
    }
  }, [_vm._v("5. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Eschatological Interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_vm._v("6. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Continuing Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_c('strong', [_vm._v("II. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Fundamental Structures")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-7"
    }
  }, [_vm._v("7. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Fullness of the Time. The Revelation of the Mystery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-8"
    }
  }, [_vm._v("8. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Mystery of Christ. Eschatology and Christology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-9"
    }
  }, [_vm._v("9. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Firstborn from the Dead. The Last Adam")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-10"
    }
  }, [_vm._v("10. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("In Christ, with Christ. The Old and the New Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-11"
    }
  }, [_vm._v("11. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Revealed in the Flesh. Flesh and Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-12"
    }
  }, [_vm._v("12. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Christ, the Son of God and the Image of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-13"
    }
  }, [_vm._v("13. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Firstborn of Every Creature")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-14"
    }
  }, [_vm._v("14. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Christ the Exalted and Coming "), _c('em', [_vm._v("Kyrios")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.7em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("III. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Life in Sin")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Present World. Aeon, Cosmos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Universality of Sin. Flesh, Adam")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Essence of Sin. Anthropological or Theological")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Wrath of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Corruption of Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Romans 7 in the Pauline “Anthropology”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Antithesis with Judaism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("No Righteousness by the Law. “Boast” and “"), _c('em', [_vm._v("Skandalon")]), _vm._v("”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Law Impotent because of the Flesh. The Bondage of the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Law as Disciplinarian unto Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Paul, Judaism, and the Old Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Revelation of the Righteousness of God")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Eschatological Character of Justification")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Righteousness of God in Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Righteousness by Faith, Without the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Justification of the Ungodly. Imputation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Judgment According to Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Reconciliation")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("God’s Reconciling Activity in Christ. The Peace of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Christ’s Death as Atonement. "), _c('em', [_vm._v("Katallagē")]), _vm._v(" and "), _c('em', [_vm._v("Hilasmos")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Ransom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Adoption of Sons. The Inheritance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.7em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The New Life")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The General Point of View")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Death and Resurrection with Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Life Through the Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The New Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Faith as the Mode of Existence of the New Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Nature of Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VII. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The New Obedience")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Indicative and Imperative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Theocentric Point of View. Sanctification")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Totalitarian Point of View. Perfection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Unity and Multiplicity. The Concreteness of the Paraenesis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('em', [_vm._v("Tertius Usus Legis")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Liberty and Conscience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Life in the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Marriage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Social Relationships")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Subjection to Civil Authority")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VIII. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Church as the People of God")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Two Principal Aspects")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('em', [_vm._v("Ekklesia")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Saints,” “Elect,” “Beloved,” “Called”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The New Covenant. Universal and Particular")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Nature of Election. God’s Purpose")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Future of Israel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.7em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IX. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Church as the Body of Christ")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Various Viewpoints and Problems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("“Body” and “Body of Christ” (Romans and 1 Corinthians)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Body and Head (Ephesians and Colossians)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Christ the Head of All Things. The Church as "), _c('em', [_vm._v("Pleroma")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Church as the People of God and as the Body of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("X. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Baptism and the Lord’s Supper")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Different Definitions of Baptism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Baptism as Means of Salvation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Redemptive Significance of the Lord’s Supper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Critical Significance of the Lord’s Supper. Self-examination")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.7em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("XI. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Upbuilding of the Church")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Church as Edifice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Extensive and Intensive Upbuilding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#sec-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Spiritual Equipment of the Church—"), _c('em', [_vm._v("Charisma")]), _vm._v(" and Ministry (Office)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#sec-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Diversity of Gifts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#sec-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Ecclesiastical Order and Discipline")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#sec-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("XII. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Future of the Lord")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Life of Expectation. The “Nearness”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("Death Before the Parousia. The “Intermediate State”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Revelation of the Man of Lawlessness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Parousia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Resurrection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Judgment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#sec-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80. "), _c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_vm._v("The Consummation. The Eternal State")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0